<template>
	<sf-data-table
		ref="CmpnMstTable"
		paging
		index
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="cmpnMstCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		creatable
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<sf-button line v-if="isButton_(scrId, 'CC')" icon="file" :onClick="registerCmpn">{{ getMessage_('SWCC000245') }}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/CmpnMst/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.cmpnMstList;
		},
		cmpnMstCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001024'), //캠페인번호
					prop: 'cmpnNo',
					width: '200px',
					sortable: false,
					align: 'center',
					highlight: true,
					clickEvent: this.openModal
				},
				{
					label: this.getMessage_('QWCC001007'), // 캠페인명
					prop: 'cmpnNm',
					headerAlign: 'center',
					width: '200px'
				},
				{
					label: this.getMessage_('QWCC001071'), // 캠페인유형
					prop: 'cmpnTypeNm',
					align: 'center',
					width: '100px'
				},
				{
					label: this.getMessage_('QWCC001028'), // 원인부품
					prop: 'causPartNo',
					headerAlign: 'center',
					width: '250px'
				},
				{
					label: this.getMessage_('QWCC001198'), // 원인부품명
					prop: 'causPartNm',
					headerAlign: 'center',
					width: '350px'
				},
				{
					label: this.getMessage_('QWCC001029'), // 원인코드
					prop: 'causNm',
					headerAlign: 'center',
					width: '340px'
				},
				// {
				// 	label: this.getMessage_('SWCC000346'), // 차종
				// 	prop: 'vehlCd',
				// 	width: '100px',
				//
				// },
				// {
				// 	label: this.getMessage_('QWCC000973'), // 기종
				// 	prop: 'tymaCdNm',
				// 	width: '100px'
				// },
				{
					label: this.getMessage_('QWCC001027'), // 대상수량
					prop: 'subjQty',
					align: 'center',
					width: '100px'
				},
				{
					label: this.getMessage_('QWCC002072'), //처리수량
					prop: 'cmpnQty',
					align: 'center',
					width: '100px'
				},
				{
					label: this.getMessage_('QWCC002073'), // 처리율
					prop: 'procRt',
					align: 'center',
					width: '100px'
				},			
				{
					label: this.getMessage_('QWCC001025'), // 캠페인 시작일
					prop: 'strtDd',
					align: 'center',
					width: '120px'
				},
				{
					label: this.getMessage_('QWCC001026'), //캠페인 종료일
					prop: 'endDd',
					align: 'center',
					minWidth: '120px'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils,
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		registerCmpn() {
			//신규 캠페인 등록 팝업 호출
			const param = {
				title: this.getMessage_('QWCC001782'),
				cmpnNo: ''
			};
			this.$emit('registerCmpn', param);
		},
		openModal(row) {
			// 캠페인 상세 팝업 호출
			const rowParam = {
				title: this.getMessage_('QWCC000994'),
				cmpnNo: row.cmpnNo
			};
			this.$emit('registerCmpn', rowParam);
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				cmpnNm: this.searchParams.cmpnNm /*캠페인명 */,
				partNm: this.searchParams.partNm /*캠페인품번 */,
				cmpnType: this.searchParams.cmpnType /* 캠페인 유형 */
			});

			const url = `${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpns/excel` + queryStr;

			const params = { url, columns: this.cmpnMstCols };

			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	}
};
</script>

<style></style>
